import { i18nGlobal } from '@/i18n/index';
import ons from '@/composable/ons';
// eslint-disable-next-line import/no-cycle
import { disableScroll, enableScroll } from '@/composable/common';

/**
 * OnsenUIアラート出力処理
 * @param displayMessage 表示メッセージ
 */
export function onsAlert(displayMessage, callback = () => {}) {
  disableScroll();
  ons.notification.alert({
    title: 'JAサイネージ',
    message: displayMessage,
    class: 'p-fixed',
    callback: () => {
      enableScroll();
      callback();
    },
  });
}

/**
 * 403エラーまたはサーバ接続不可(502,503,504)時OnsenUIアラート出力処理
 */
export function onsForbiddenOrConnectionErrorAlert() {
  onsAlert(i18nGlobal.t('message.SIGNAGE001E'));
}

/**
 * Axiosタイムアウト時OnsenUIアラート出力処理
 */
export function onsAxiosTimeoutErrorAlert(callback = () => {}) {
  onsAlert(i18nGlobal.t('message.SIGNAGE004E'), callback);
}

/**
 * クライアントの回線断時OnsenUIアラート出力処理
 */
export function onsClientConnectionErrorAlert() {
  onsAlert(i18nGlobal.t('message.SIGNAGE003E'));
}

/**
 * 予期せぬエラー発生時OnsenUIアラート出力処理
 */
export function onsUnexpectedErrorAlert() {
  onsAlert(i18nGlobal.t('message.SIGNAGE005E'));
}

/**
 * @vuese
 * 処理承認時OnsenUIアラート出力処理
 */
export function onsConfirm(displayMessage) {
  disableScroll();
  return new Promise((resolve, reject) => {
    ons.notification
      .confirm({
        title: '確認',
        messageHTML: displayMessage,
        buttonLabels: ['いいえ', 'はい'],
        class: 'p-fixed',
      })
      .then((response) => {
        enableScroll();
        if (response) {
          resolve();
        } else {
          reject();
        }
      });
  });
}

/**
 * @vuese
 * 通知OnsenUIアラート出力処理
 */
export function onsNotification(displayMessage) {
  disableScroll();
  return new Promise((resolve) => {
    ons.notification
      .confirm({
        title: '通知',
        messageHTML: displayMessage,
        buttonLabels: ['OK'],
        class: 'p-fixed',
      })
      .then(() => {
        enableScroll();
        resolve();
      });
  });
}
